import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import CustomerApprovalLeadList from "./CustomerLeadApproval";
import { useLocation } from "react-router-dom";
import Heading from "../../components/Heading";

const TABS = [
  { label: "CP Approval", key: "1", userType: "CP" },
  { label: "Client Approval", key: "2", userType: "CLIENT" },
  // { label: "Company Approval", key: "3", userType: "COMPANY" },
];

const AllApprovalTabs = () => {
  const [activeKey, setActiveKey] = useState("1");
  const [destroy, setDestroy] = useState(false);

  const { state } = useLocation();

  useEffect(() => {
    if (state) setActiveKey(state || "1");
  }, [state]);

  const changeTab = (key) => {
    setActiveKey(key);
    setDestroy(false);
  };

  return (
    <div className="p-1">
      <Heading title="Approvals" navigateTo="/onboarding-settings" />
      <div className="global-card-tab-container">
        <Tabs
          activeKey={activeKey}
          destroyInactiveTabPane={destroy}
          onChange={changeTab}
          items={TABS.map(({ label, key, userType }) => ({
            label,
            key,
            children: (
              <CustomerApprovalLeadList
                userType={userType}
                tabKey={key}
                url="/all-approvals"
                actionPresent={true}
              />
            ),
          }))}
        />
      </div>
    </div>
  );
};

export default AllApprovalTabs;
